import { formatCurrency } from 'shared/util/formatCurrency';
import { ReactComponent as RepeatSvg } from 'assets/images/repeat.svg';

const ProductPriceInfo = ({
  price,
  count,
  repeat,
}: {
  price: number;
  count?: number;
  repeat?: boolean;
}) => {
  return (
    <div className="flex flex-row gap-2 text-xs font-semibold">
      <div className="flex flex-row gap-1 text-content-base-default">
        <span>{formatCurrency(price)}</span>
        {typeof count === 'number' && count > 0 && (
          <span className="col-span-2 opacity-50">x&nbsp;{count}</span>
        )}
        {repeat && (
          <RepeatSvg width="16px" height="16px" title="Recurring charge" />
        )}
      </div>
    </div>
  );
};

export default ProductPriceInfo;
